import { experimentHelper } from '../../util/experiment_helper'

export function setupExperiment (app, visitorId, trackingOnHold = false) {
  if (trackingOnHold) return
  if (!visitorId) return

  experimentHelper.setup(visitorId)
}
